/**
 * prod1: подпись присутствия собеседника в шапке чата.
 * «в сети» / «был(а) в сети только что / 5 мин назад / сегодня в 14:05 / вчера в 09:10 / 12.10 в 18:30».
 */
const pad = (n: number) => String(n).padStart(2, '0');

export const formatLastSeen = (iso: string | null | undefined, now: Date = new Date()): string | null => {
  if (!iso) return null;
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return null;
  const diffMin = Math.floor((now.getTime() - at.getTime()) / 60000);
  const prefix = 'был(а) в сети';
  if (diffMin < 1) return `${prefix} только что`;
  if (diffMin < 60) return `${prefix} ${diffMin} мин назад`;
  const time = `${pad(at.getHours())}:${pad(at.getMinutes())}`;
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  if (at.getTime() >= startOfToday) return `${prefix} сегодня в ${time}`;
  if (at.getTime() >= startOfToday - 86400000) return `${prefix} вчера в ${time}`;
  return `${prefix} ${pad(at.getDate())}.${pad(at.getMonth() + 1)} в ${time}`;
};
